import * as React from 'react'
import { cn } from '~/lib/utils'

export type RequiredIndicatorProps = {
  className?: string
}

export const RequiredIndicator = ({ className }: RequiredIndicatorProps) => {
  return (
    <span className={cn('ml-1 text-red-300 text-sm', className)} aria-label="required">
      *
    </span>
  )
}
